import React from "react"
import { Script } from "gatsby"

const GuidedZaps = ({ ids }) => {
  const elementId = `guided-zaps-${ids.join("-")}`

  return (
    <>
      <Script
        src={`https://zapier.com/zapbook/embed/widget.js?guided_zaps=${ids.join(
          ",",
        )}&html_id=${elementId}`}
      />

      <div id={elementId} className="mb-4" />
    </>
  )
}

export default GuidedZaps
